import script from "./CandidateSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateSearch.vue?vue&type=script&setup=true&lang=js"

import "./CandidateSearch.vue?vue&type=style&index=0&id=e99334de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e99334de"]])

export default __exports__